const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,30}$/;

export const isPasswordValid = (password: string | null): boolean => {
  if (!password) {
    return false;
  }
  return passwordRegex.test(password);
};
